import { useQuery } from "@tanstack/react-query";
import { fetchApiGet } from "../../../../utils";
import { TtOrderMetadata } from "../types";

export type ReasonCode =
  | "missing_customer"
  | "missing_order_type"
  | "missing_otc_type"
  | "missing_crop_year";

export interface NeedsAttentionRow {
  guid_order_id: string;
  exchange_event_time: string;
  trading_account_name: string | null;
  user_name: string | null;
  instrument_name: string | null;
  buy_sell_type: string | null;
  order_quantity: string | null;
  order_uom_quantity: string | null;
  working_quantity: string | null;
  remaining_quantity: string | null;
  filled_quantity: string | null;
  limit_price: string | null;
  text_a: string | null;
  text_b: string | null;
  text_c: string | null;
  text_tt: string | null;
  metadata: TtOrderMetadata | null;
  needs_attention_reasons: ReasonCode[];
}

export interface NeedsAttentionResponse {
  snapshot_id: string | null;
  snapshot_taken_at: string | null;
  rows: NeedsAttentionRow[];
}

/**
 * Which orders the backend loads:
 *  - missing_info: has_necessary_info = false
 *  - has_info:     has_necessary_info = true
 *  - ignored:      should_ignore_order = true
 *  - all:          no filter on either column
 */
export type OrderPreset = "missing_info" | "has_info" | "ignored" | "all";

export const NEEDS_ATTENTION_QUERY_KEY = ["risk", "brokerage", "tt", "v2", "needs-attention"] as const;

export function useListNeedsAttention(preset: OrderPreset, options?: { enabled?: boolean }) {
  return useQuery({
    queryKey: [...NEEDS_ATTENTION_QUERY_KEY, preset],
    queryFn: () => {
      const params = new URLSearchParams();
      params.set("order_preset", preset);
      return fetchApiGet<NeedsAttentionResponse>("/brokerage/tt/v2/needs-attention", params);
    },
    enabled: options?.enabled ?? true,
  });
}
